import styled from "styled-components";

export const SectionContainer = styled.div`
display: grid;
height: auto;
width: 100vw;
padding: 3rem;
background-color:black;
position:relative;


`;
